<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
.button:disabled {
  cursor: no-drop;
}
</style>

<template>
  <div class="card">
    <header class="card-header bg-primary text-white d-flex align-items-center font-weight-bold"> Data Peserta Level 
    </header>
     <div class="card-body">
        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <label for="" class="font-weight-bold">Pilih Periode</label>
                <multiselect
                  class="multi-select"
                  label="label"
                  placeholder="Pilih Periode"
                  :show-labels="false"
                  required
                  v-model="periode"
                  :options="dataTahun"
                ></multiselect>
            </div>
            <div class="col-sm-12 col-xl-6">
                <label for="exampleFormControlSelect1">Nama Peserta</label>
                <input type="text" v-model="searchData.namaPeserta" class="form-control" placeholder="Kode / Nama Sertifikasi">
            </div>
        </div>
        <br>
      </div>
    <div class="card-body">
    <ul class="nav nav-tabs bg-active border-0 border-bottom-0" id="myTab" role="tablist">            
          <li class="nav-item" ref="tablunas">
            <div
              class="nav-link p-3 px-4 font-weight-bold text-white active "
              id="home-tab"
              data-toggle="tab"
              href="#home"
              style="cursor: pointer"
              role="tab"
              @click="tabAction('lunas')"
              aria-controls="home">
                Lunas
                <span class="badge badge-success text-white">0</span>
              </div>
          </li>
          <li class="nav-item">
            <div
              class="nav-link p-3 px-4 font-weight-bold text-white "
              id="profile"
              data-toggle="tab"
              href="#profile"
              style="cursor: pointer"
              role="tab"
              @click="tabAction('belum_lunas')"
              aria-controls="profile" >
                Belum Lunas
                <span class="badge badge-danger text-white">0</span>
              </div>
          </li>
        </ul>
        <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nama="{ item }">              
              <td class="py-2">{{ item.nama_peserta ? item.nama_peserta : "-" }}</td>
            </template>
            <template #email="{ item }">              
              <td class="py-2">{{ item.email ? item.email : "-" }}</td>
            </template>
            <template #level="{ item }">              
              <td class="py-2">{{ item.level ? item.level : "-" }}</td>
            </template>
             <template #id_invoice="{ item }">              
              <td class="py-2">{{ item.id_invoice ? item.id_invoice : "-" }}</td>
            </template>
            
        </CDataTable>
    </div>
</div>
</template>
<script>

import PeriodeService from "@/services/datamaster/periode.service";
import DataPesertaService from "@/services/sertifikasi/data-peserta.service";

const fields = [
  { key: "no", label: "No. "},
  { key: "nama_peserta", label: "Nama Peserta"},
  { key: "email", label: "Email"},
  { key: "level", label: "Level"},
  { key: "periode", label: "Periode"},
  { key: "id_invoice", label: "Invoice"}
];

export default {
    data() {
        return {
            fields,
            search : '',
            items: [],
            indexed : 0, 
            periode: {}, 
            dataTahun: [],
            timeOutFilterNamaPeserta : null,
            searchData: {
              currentPage:0,
              pageSize:10,
              statusPembayaran:'lunas',
              periode: {}, 
              namaPeserta: ""
            }
        }
    },
    watch: {
      'periode' : function(value) {
        console.log(value)
        this.searchData.periode = value.value
        this.getData(this.searchData.currentPage,this.searchData.pageSize,this.searchData.statusPembayaran,this.searchData.periode,this.searchData.namaPeserta);
      }, 
      'searchData.namaPeserta' : function(value) {
        clearTimeout(this.timeOutFilterNamaPeserta);
        var vm = this;
        this.timeOutFilterNamaPeserta = setTimeout(function(){
          vm.searchData.namaPeserta = value;
          vm.getData(vm.searchData.currentPage,vm.searchData.pageSize,vm.searchData.statusPembayaran,vm.searchData.periode,vm.searchData.namaPeserta);
        },1000);
      }
    },
    mounted() {
      this.getPeriode();
    },
    methods: {  
      getData(
        currentPage,
        pageSize,
        statusPembayaran, 
        periode,
        namaPeserta
      ) {
        console.log(this.searchData)
        DataPesertaService.getSertifikasiLevel( currentPage, pageSize, statusPembayaran, periode, namaPeserta)
        .then((res) => {
          console.log(res)
          this.items = res.data.data
        }).catch((err) => {
          console.log(err.response)
        })
      },
      tabAction(string) {
        this.searchData.statusPembayaran  = string;
        this.getData(this.searchData.currentPage,this.searchData.pageSize,this.searchData.statusPembayaran,this.searchData.periode,this.searchData.namaPeserta);
      }, 
       getPeriode() {
        PeriodeService.getPeriodeSelect()
          .then((response) => {
            console.log(response)
            this.dataTahun = response.data.data;
            this.periode = this.dataTahun.find((el) => el.status === "1");
            this.searchData.periode = this.periode.value;
            // this.formFilter.periode = periode.value;
          })
          .catch((error) => {
            // comment console console.log(error);
          });
      },
    },
    
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
